import { render, staticRenderFns } from "./ProcessDetails.vue?vue&type=template&id=25f5f659&scoped=true&"
import script from "./ProcessDetails.vue?vue&type=script&lang=js&"
export * from "./ProcessDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetails.vue?vue&type=style&index=0&id=25f5f659&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5f659",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
